"use strict";

import { ArrangementView } from "./Views/ArrangementView";
import { BloomView } from "./Views/BloomView";
import { GeometryView } from "./Views/GeometryView";
import { RandomView } from "./Views/RandomView";

export const Views = {
    ArrangementView, BloomView, GeometryView, RandomView
}